module.exports = __webpack_public_path__ + "img/20200109160423712.a6a15996.jpg";